export const DollarCircleIcon = () => {
    return (
        <svg width="100%" height="100%" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M30 55C43.8071 55 55 43.8071 55 30C55 16.1929 43.8071 5 30 5C16.1929 5 5 16.1929 5 30C5 43.8071 16.1929 55 30 55Z"
                stroke="url(#paint0_linear_969_23459)" strokeWidth="5"/>
            <path
                d="M30 15V45M37.5 23.75C37.5 20.3 34.1425 17.5 30 17.5C25.8575 17.5 22.5 20.3 22.5 23.75C22.5 27.2 25.8575 30 30 30C34.1425 30 37.5 32.8 37.5 36.25C37.5 39.7 34.1425 42.5 30 42.5C25.8575 42.5 22.5 39.7 22.5 36.25"
                stroke="url(#paint1_linear_969_23459)" strokeWidth="4" strokeLinecap="round"/>
            <defs>
                <linearGradient id="paint0_linear_969_23459" x1="33.4483" y1="-22.9412" x2="101.988" y2="84.0791"
                                gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F83700"/>
                    <stop offset="1" stopColor="#F7CB2A"/>
                </linearGradient>
                <linearGradient id="paint1_linear_969_23459" x1="31.0345" y1="-1.7647" x2="74.9565" y2="32.5261"
                                gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F83700"/>
                    <stop offset="1" stopColor="#F7CB2A"/>
                </linearGradient>
            </defs>
        </svg>
    );
};